import InitApp from "./InitApp";

function App() {
  return <InitApp />;
}

export default App;
